import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import lobbyDecorImg from "@/assets/home-lobby-decor.png";
import restaurantImg from "@/assets/home-restaurant-interior.png";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";

const HomeAbout = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();
  return (
    <section id="welcome" className="hotel-section bg-card">
      <div className="hotel-container">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-10 items-center">
          <div className="flex justify-center lg:justify-end">
            <div className="w-[280px] md:w-[320px] h-[340px] md:h-[420px] rounded-t-[50%] overflow-hidden shadow-elevated">
              <img src={lobbyDecorImg} alt="Hotel Lobby" loading="lazy" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="text-center space-y-5 py-4">
            <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-light text-foreground">
              {get("about_title") || t.homeAbout.aboutHeading}
            </h2>
            <div className="w-12 h-px bg-accent mx-auto" />
            <p className="font-body text-sm md:text-base text-muted-foreground leading-relaxed max-w-sm mx-auto">
              {get("about_description") || t.homeAbout.shortText}
            </p>
            <Button variant="hotel" size="lg" asChild>
              <Link to="/about">{get("about_cta") || t.homeAbout.cta}</Link>
            </Button>
          </div>
          <div className="flex justify-center lg:justify-start">
            <div className="w-[280px] md:w-[320px] h-[340px] md:h-[420px] rounded-t-[50%] overflow-hidden shadow-elevated">
              <img src={restaurantImg} alt="Hotel Restaurant" loading="lazy" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;
